import Vue from 'vue'
import VueRouter from 'vue-router'


import routes from './routes';
import routes_jp from "@/router/routes_jp";

let routes2 = routes.concat(routes_jp);
// console.log(routes2)


Vue.use(VueRouter)



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes2,
})

export default router
